import { render } from "./StockEditPage.vue?vue&type=template&id=10e3b9e2"
import script from "./StockEditPage.vue?vue&type=script&lang=js"
export * from "./StockEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__